import Header from "./components/header";
import Animations from "./components/animations";
import { hashScroll, refresh } from "./components/global";
import "./components/homepage-hero";
import "./components/toggle-compare";
import "./components/use-cases";
import "./components/stat-compare";
import "./components/demo";
import "./components/team-tabs";
import "./components/question-stack";
import "./components/process-rail";
import "./components/counters";
import "./components/testimonial-rotator"; 
import flatpickr from "flatpickr";
import jQuery from "jquery";
const $ = jQuery;
import { AsYouType } from 'libphonenumber-js';
export default new (
    class App {
        constructor() {
            document.addEventListener("DOMContentLoaded", () => {
                this.domReady();
            })
        }

        domReady = () => {
            this.domMap();
            this.init();
            this.domManiplation();
            this.bindEvents();
            this.accordionInit();
            this.tableOfContent();
            this.calendar()
            this.floatingCTA();
            // this.stickyDiv();
        }

        domMap = () => {
            this.window = $(window);
            this.copy = $('.copy-link');
            this.body = $('body');
            this.siteOverlay = $('.site-overlay');
            this.popupBtn = $('[data-toggle="modal"]');
            this.popupCloseBtn = $('.popup-close');
            this.popup = $('.site-modal-wrapper');
            this.additionalContentBtn = $('.image-with-content .site-button');
            this.teamPupBtn = $('.team-member > button');
            this.filterBtn = $('.category-filter button');
            this.filterMobileBtn = $('button.mobile-filter');
            this.filterTab = $('.tab-panel');
            this.formButton = $('button.gform-button[type="submit"]');
            this.dataTimePicker = $('.date-time')
            this.floatingNotice = $('.floating-cta')
        }

        init = () => {
            new Header();
            new Animations();
            hashScroll();
        }

        domManiplation = () => {
            // if (this.newDetail.length) {
            //     const iframe = document.querySelectorAll('.comm-content iframe');
            //     const image = document.querySelectorAll('.comm-content p > img');
            //     iframe.forEach((el, i) => {
            //         const parent = el.parentElement;
            //         if (!parent.classList.contains('ratio')) {
            //             parent.classList.add('ratio', 'ratio-16x9');
            //         }
            //     });
            //     image.forEach((el, i) => {
            //         const parent = el.parentElement;
            //         if (!parent.classList.contains('img-fluid')) {
            //             parent.classList.add('img-fluid');
            //         }
            //     });
            // }
            if (this.formButton.length) {
                this.formButton.each((i, el) => {
                    const value = $(el).text();
                    $(el).html('<span class="text">' + value + '</span><span></span>');
                })
            }
        }

        bindEvents = () => {
            //this.openShareBtn.on('click', this.openShareEl);
            this.copy.on('click', this.copyLink);
            this.window.on('resize', () => {
                refresh();
                this.accordionInit(); // re-run accordion init
            });
            if (this.popupBtn.length > 0) {
                this.sitePopup();
            }
            if (this.additionalContentBtn.length > 0) {
                this.expandAdditionalContent();
            }
            if (this.teamPupBtn.length > 0) {
                this.teamPopup();
            }

            if (this.filterBtn.length > 0) {
                this.teamsFilter();
            }
        }

        copyLink = (e) => {
            const current = e.currentTarget;
            const text = $(current).data('text')
            $(current).append(`<span class="position-absolute d-inline-block">${text}</span>`)
            navigator.clipboard.writeText(window.location.href);
            setTimeout(() => {
                $(current).find('span').remove();
            }, 2000);
        }

        sitePopup = () => {
            this.popupBtn.on('click', (e) => {
                const target = e.currentTarget.dataset.target;
                // const target = e.target.dataset.target;
                // console.log(target)
                this.siteOverlay.addClass('active');
                this.body.addClass('overflow-hidden');
                $(`#${target}`).removeClass('hidden');
            })

            this.popupCloseBtn.on('click', (e) => {
                const current = e.currentTarget;
                this.body.removeClass('overflow-hidden');
                $(current).parents('.site-modal-wrapper').addClass('hidden');
                this.siteOverlay.removeClass('active');
            })

        }

        teamPopup = () => {
            const closePopup = (el) => {
                $(el).on('click', () => {
                    $(el).parents('.site-modal-wrapper').addClass('opacity-0');
                    this.body.removeClass('overflow-hidden');
                    this.siteOverlay.removeClass('active');
                    setTimeout(() => {
                        $(el).parents('.site-modal-wrapper').remove();
                    }, 100);
                })
            }

            this.teamPupBtn.each((i, el) => {
                $(el).on('click', (e) => {
                    e.preventDefault();
                    this.siteOverlay.addClass('active');
                    const copyElms = $(e.currentTarget).find('.wrapper').html();
                    const generatePopup = `
                        <div class="site-modal-wrapper fixed left-0 right-0 top-0 bottom-0 overflow-y-auto z-[1001] p-5">
                            <div class="max-w-[91.4rem] w-full site-modal m-auto flex items-center">
                                <div class="bg-white member-role-brief rounded-[1.5rem] p-[3rem] pt-[5rem] sm:p-10 relative">
                                    <button type="button" class="popup-close absolute" data-dismiss="modal"><img src="/wp-content/themes/p360/src/images/close.svg" width="30" height="30" alt="Modal Close"><span class="sr-only">Close Modal</span></button>
                                    <div class="flex flex-wrap items-start gap-5 md:gap-[2rem] lg:gap-10">
                                        ${copyElms}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                    this.body.addClass('overflow-hidden');
                    this.siteOverlay.after(generatePopup);
                    const removePopup = $('.popup-close')
                    closePopup(removePopup);
                })
            })
        }

        expandAdditionalContent = () => {
            this.additionalContentBtn.on('click', (e) => {
                const current = e.currentTarget;
                $(current).toggleClass('active');
                $(current).parent().prev('.read-more-content').toggle();
            })
        }

        teamsFilter = () => {
            this.filterBtn.each((i, el) => {
                $(el).on('click', (e) => {
                    const currentTarget = $(e.currentTarget);
                    const targetId = currentTarget.attr('data-tab-target');
                    const text = currentTarget.text();
                    if (!$(currentTarget).hasClass('active')) {
                        this.filterMobileBtn.text(text);
                        currentTarget.parent().find('.active').attr('aria-selected', 'false');
                        currentTarget.parent().find('.active').removeClass('active');
                        currentTarget.attr('aria-selected', 'true');
                        currentTarget.addClass('active');
                        this.filterTab.removeClass('active');
                        this.filterTab.removeClass('show');
                        $(targetId).addClass('active');
                        if (this.filterMobileBtn.hasClass('active')) {
                            this.filterMobileBtn.toggleClass('active')
                            this.filterMobileBtn.next().toggleClass('show-category-options')
                        }
                        setTimeout(() => {
                            $(targetId).addClass('show');
                        }, 100);
                    }
                });
            })

            this.filterMobileBtn.on('click', (e) => {
                this.filterMobileBtn.toggleClass('active');
                this.filterMobileBtn.next().toggleClass('show-category-options')
            })
        }

        // start - footer menu converted to accordion for mobile screen
        accordionInit = () => {
            const isMobile = window.innerWidth <= 768;
            const $toggles = $('.custom-accordion-toggle');
            const $contents = $('.custom-accordion-content');
            $toggles.off('click'); // Remove any previous click handlers
            if (isMobile) {
                $contents.hide(); // Hide all accordion content initially

                $toggles.removeClass('active').on('click', function () {
                    const $this = $(this);
                    const $content = $this.next('.custom-accordion-content');
                    if (!$content.length) return; // If no content found, exit

                    $toggles.not($this).removeClass('active');  // Close other accordions
                    $contents.not($content).slideUp(200);

                    $this.toggleClass('active');    // Toggle current accordion
                    $content.stop(true, true).slideToggle(200);
                });

            } else {
                // Show all content on desktop & remove active state on desktop
                $contents.show();
                $toggles.removeClass('active');
            }
        };
        // end

        tableOfContent = () => {
            const toggleButton = document.getElementById('toggleButton');
            const myList = document.getElementById('myList');
            if (toggleButton && myList) {
                myList.style.display = 'block';
                toggleButton.textContent = 'Hide';
                toggleButton.classList.add('active');
                toggleButton.addEventListener('click', function () {
                    if (myList.style.display === 'none') {
                        myList.style.display = 'block';
                        toggleButton.textContent = 'Hide';
                        toggleButton.classList.add('active');
                    } else {
                        myList.style.display = 'none';
                        toggleButton.textContent = 'Show';
                        toggleButton.classList.remove('active');
                    }
                });
            }

            // Below code is created to show the table of content ul li list on the article page
            // Get the JSON data from the script tag
            const dataElement = document.getElementById('acf-toc-data');
            if (!dataElement) {
                // console.error('ACF Repeater data not found.');
                return;
            }
            const tocData = JSON.parse(dataElement.textContent);
            const shortcodeList = document.querySelector('.toc-list-shortcode');
            const stickyList = document.querySelector('#myStickyDiv ul');
            // Generate and inject the HTML if data exists
            if (tocData && Array.isArray(tocData)) {
                // Function to build and inject the list items
                function injectToc(container) {
                    let itemCounter = 1;
                    container.innerHTML = ''; // Clear existing content
                    tocData.forEach(item => {
                        if (item.title && item.title.trim() !== '') {
                            const li = document.createElement('li');
                            const a = document.createElement('a');
                            a.href = `#section-${itemCounter}`;
                            a.textContent = item.title;
                            li.appendChild(a);
                            container.appendChild(li);
                        }
                        itemCounter++;
                    });
                    hashScroll();
                }
                // Inject into the shortcode container
                if (shortcodeList) {
                    injectToc(shortcodeList);
                }
                // Inject into the sticky container
                if (stickyList) {
                    injectToc(stickyList);
                }
            }
        };

        calendar = () => {

            /* jQuery(document).on('gform/post_init', function (event, formId) {
                // Replace 5 with your Phone field ID
                const $field = jQuery('input[type="tel"]');
                // const $field = jQuery('#input_' + formId + '_5');

                if (!$field.length) return;

                // Initialize
                if (!$field.val()) {
                    $field.val('+');
                }

                // $field.on('focus', function () {
                //     if (this.value === '') {
                //         this.value = '+';
                //     }
                // });

                $field.on('input', function () {
                    // Keep only digits after +
                    let value = this.value.replace(/[^\d+]/g, '');

                    // Ensure only one +
                    value = '+' + value.replace(/\+/g, '');

                    this.value = value;
                });

                $field.on('keydown', function (e) {
                    const pos = this.selectionStart;

                    // Prevent deleting the +
                    if (
                        (e.key === 'Backspace' && pos <= 1) ||
                        (e.key === 'Delete' && pos === 0)
                    ) {
                        e.preventDefault();
                    }

                    // Allow navigation keys
                    if (
                        ['ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'].includes(e.key)
                    ) {
                        return;
                    }

                    // Allow Ctrl/Cmd shortcuts
                    if (e.ctrlKey || e.metaKey) {
                        return;
                    }

                    // Allow digits only
                    if (!/^\d$/.test(e.key) &&
                        !['Backspace', 'Delete'].includes(e.key)) {
                        e.preventDefault();
                    }
                });

                $field.on('paste', function (e) {
                    e.preventDefault();

                    const pasted = (e.originalEvent || e).clipboardData.getData('text');
                    const digits = pasted.replace(/\D/g, '');

                    this.value = '+' + digits;
                });
            }); */

            if (this.dataTimePicker.length) {

                // const initialCountryLookup = async () => {
                //     const res = await fetch("https://ipapi.co/json");
                //     const data = await res.json();
                //     return data.country_code;
                // };
                // const input = telephone;
                // const iti = intlTelInput(input, {
                //     initialCountryLookup,
                //     loadUtils: () => import("intl-tel-input/utils"),
                // });
                let showCustomCalander = false;
                const customButton = document.getElementById('custom-gf-submit'); //Custom trigger btn outside form
                document.addEventListener('gform/post_init', function (event) {
                    const selectionOptions = $('.selected-options')
                    const telephone = $('input[type="tel"]');
                    const customBtnNext = $('.custom-form-btns button.next');
                    const customBtnCalendar = $('.custom-form-btns button.calendar-booking');
                    const eventPicker = $('.event-picker');
                    const forceHideSlot = $('#choice_4_9_2'); // Hide from user
                    forceHideSlot.parent().addClass('hidden')

                    telephone.on('keyup', function (e) {
                        const value = e.target.value;
                        const formatedValue = new AsYouType().input(value)
                        console.log(formatedValue.includes("+"))
                        e.target.value = formatedValue.includes("+") ? formatedValue : formatedValue == '' ? '' : '+' + formatedValue
                    })

                    customBtnCalendar.on('click', function () {
                        $('#choice_4_9_2').prop('checked', true)
                        showCustomCalander = true
                    })
                    customBtnNext.on('click', function () {
                        $('#choice_4_9_2').prop('checked', false)
                        showCustomCalander = false;
                    })

                    let selectedOption = '';
                    selectionOptions.html('');
                    $('.track-selection input:checked').each(function (i, el) {
                        const captureLabel = $(el).next().text();
                        selectedOption += `<li>${captureLabel}</li>`;
                        return selectedOption
                    })
                    selectionOptions.html(selectedOption)




                });

                /* This trigger for custom button outside gravity forms */
                $('.triggers button').on('click', function () {
                    const target = $(this).data('target');
                    const form = document.querySelector('#gform_4').querySelector('#gform_submit_button_4');
                    // console.log(form)

                    if ($(this).hasClass('prev')) {
                        $('#gform_page_4_3').hide();
                        $('#gform_page_4_3').removeClass('.show');
                        $('.event-picker').addClass('hidden')
                        $('#gform_page_4_2').show();
                        var $nativePrevBtn = $('#gform_wrapper_4 .gform_page:visible .gform_previous_button');

                        // 3. Trigger the click if the native button exists
                        if ($nativePrevBtn.length > 0) {
                            $nativePrevBtn.click();
                        } else {
                            console.warn('Gravity Forms native previous button not found on this page.');
                        }
                    }
                })

                const fp = flatpickr('.custom-event input', {
                    enableTime: true,
                    inline: true,
                    altFormat: "F j, Y",
                    dateFormat: "l, F d, Y, h:i K",
                    minDate: new Date().fp_incr(1),
                    maxDate: new Date().fp_incr(180),
                    minTime: "09:00",
                    maxTime: "16:30",
                    minuteIncrement: "30",
                    onChange: function () {

                        var tzInput = document.querySelector('.utc-time input');
                        const getValue = $('.custom-event input').val();
                        $('.date-time input').val(getValue);
                        if (!tzInput) return;
                        try {
                            tzInput.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        } catch (e) {
                            tzInput.value = 'UTC';
                        }

                    },
                    disable: [
                        function (date) {
                            // Return true to disable Saturday (6) and Sunday (0)
                            return (date.getDay() === 0 || date.getDay() === 6);
                        },
                        // {
                        //     from: "Thursday, July 30, 2026, 09:00 AM",
                        //     to: "Wednesday, August 12, 2026, 4:00 PM"
                        // }
                    ],
                });

                document.addEventListener('gform/post_render', function (event) {
                    if (event.detail.currentPage == 3 && showCustomCalander) {
                        $(event.target.body).find('.event-picker').removeClass('hidden')
                        $(event.target.body).find('.gform_page:last-child').removeClass('show')
                        $('#choice_4_9_2').prop('checked', true)
                        if ($(event.target.body).find('.gform_validation_error #validation_message_4_11').length == 1) {
                            const errTxt = $(event.target.body).find('.gform_validation_error #validation_message_4_11').text();
                            $(event.target.body).find('.event-picker .custom-error').remove()
                            $(event.target.body).find('.event-picker .custom-form-btns').before(`<div class="custom-error">${errTxt}</div>`)
                        }
                        // console.log($(event.target.body).find('.gform_validation_error #validation_message_4_11').text())

                    } else {
                        $(event.target.body).find('.gform_page:last-child').addClass('show')
                        $(event.target.body).find('.event-picker').addClass('hidden')
                        $(event.target.body).find('.event-picker .custom-error').remove()
                        fp.clear();
                        $('#choice_4_9_2').prop('checked', false)
                    }
                });

                if (!customButton) {
                    return;
                }
                customButton.addEventListener('click', async function () {
                    const form = document.getElementById('gform_4');
                    console.log(form, 'N2')
                    if (!form) {
                        console.error('Gravity Forms form #4 not found.');
                        return;
                    }

                    const submission = window.gform?.submission;

                    if (!submission?.submitForm) {
                        console.error('Gravity Forms submission API is not available.');
                        return;
                    }

                    // Prevent duplicate submissions
                    if (!submission.lockSubmission(form)) {
                        return;
                    }

                    try {
                        await submission.submitForm(
                            form,
                            submission.SUBMISSION_TYPE_SUBMIT,
                            submission.getSubmissionMethod(form)
                        );
                    } catch (error) {
                        submission.unlockSubmission(form);
                        console.error('Gravity Forms submission failed:', error);
                    }
                });
            }
        }

        // stickyDiv = () => {
        //     const stickyDiv = document.getElementById('myStickyDiv'); 
        //     if (!stickyDiv) return; 
        //     const originalOffsetTop = stickyDiv.offsetTop; 
        //     window.addEventListener('scroll', function() {
        //         if (window.scrollY >= originalOffsetTop) {
        //             stickyDiv.classList.add('is-sticky');
        //         } else {
        //             stickyDiv.classList.remove('is-sticky');
        //         }
        //     });
        // };

        floatingCTA = () => {
            if (this.floatingNotice.length > 0) {
                document.querySelectorAll('.floating-cta').forEach(function (cta) {
                    var closeBtn = cta.querySelector('.js-floating-cta-close');
                    var footer = document.querySelector('footer');
                    var offset = parseInt(cta.getAttribute('data-scroll-offset'), 10) || 300;

                    if (!footer) {
                        return;
                    }

                    var dismissed = false;
                    var footerNear = false;

                    function update() {
                        if (dismissed) {
                            cta.classList.remove('is-visible');
                            return;
                        }
                        var pastThreshold = window.scrollY > offset;
                        cta.classList.toggle('is-visible', pastThreshold && !footerNear);
                    }

                    // Treat the footer as "about to appear" a little before it actually
                    // enters the viewport, so the floating CTA steps aside in good time.
                    var io = new IntersectionObserver(
                        function (entries) {
                            entries.forEach(function (entry) {
                                footerNear = entry.isIntersecting;
                            });
                            update();
                        },
                        { rootMargin: '0px 0px 150px 0px', threshold: 0 }
                    );
                    io.observe(footer);

                    if (closeBtn) {
                        closeBtn.addEventListener('click', function () {
                            dismissed = true;
                            update();
                        });
                    }

                    window.addEventListener('scroll', update, { passive: true });
                    window.addEventListener('resize', update);
                    update();
                });
            }
        }

    }
);